<template>
	<div class="c-knowledge-area-box">
		<BaseH2 v-if="title" class="text-h3 mb-sm/v" v-text="title" />

		<div class="grid grid-cols-2 gap-1 w-full bg-blue bg-opacity-70">
			<LinkTile
				v-for="item in items"
				:key="item.key"
				:to="item.url"
				class="
					c-knowledge-area-box__item
					group
					bg-blue
					text-white
					overflow-hidden
				"
				:aria-labelledby="
					[
						item.name
							? `c-knowledge-area-box__title-${item.key}`
							: null,
						`c-knowledge-area-box__button-${item.key}`,
					]
						.filter(Boolean)
						.join(' ')
				"
			>
				<article
					class="
						c-knowledge-area-box__content
						flex flex-col
						justify-between
						w-full
						h-full
						px-xs/h
						py-xs/v
					"
				>
					<header
						class="
							w-full
							h-full
							>=768:h-auto
							mb-xs/v
							flex flex-col
							>=768:flex-row
							gap-x-2xs/h gap-y-28
							>=768:items-center
						"
						:style="{
							minHeight: 'var(--icon-size, 48px)',
						}"
					>
						<AreaIcon
							:style="{
								width: 'var(--icon-size, 48px)',
								height: 'var(--icon-size, 48px)',
							}"
							class="self-start flex-shrink-0"
							:src="item.iconUrl"
							invert
						/>

						<BaseH4
							v-if="item.name"
							:id="`c-knowledge-area-box__title-${item.key}`"
							class="
								c-knowledge-area-box__heading
								inline-flex
								items-center
								mt-auto
								>=768:mt-0
								<768:min-h-0
							"
							:style="{
								minHeight: 'var(--icon-size, 48px)',
							}"
							:level-offset="2"
							v-html="item.name"
						/>
					</header>
					<ul
						v-if="item.links && item.links.length > 0"
						class="
							c-knowledge-area-box__hidden-content
							hidden
							>=768:flex
							flex-wrap
							gap-8
						"
					>
						<li v-for="(link, index) in item.links" :key="index">
							<NuxtLinkExt
								:to="link.url"
								:target="link.target"
								class="
									inline-flex
									items-center
									px-10
									py-5
									min-h-28
									border border-white border-opacity-30
									text-white
									hover:bg-white
									hover:border-opacity-100
									hover:text-theme
									focus:bg-white
									focus:border-opacity-100
									focus:text-theme
									transition-colors
									duration-200
									ease-in-out
									rounded-25
									text-body-xs
									-mx-1
								"
							>
								{{ link.name }}
							</NuxtLinkExt>
						</li>
					</ul>
				</article>
			</LinkTile>

			<!-- Filler -->
			<div
				v-for="(item, index) in 3"
				:key="index"
				class="c-knowledge-area-box__stand-in bg-blue"
			></div>
		</div>
	</div>
</template>

<script>
import LinkTile from '~/components/shared/LinkTile';
import AreaIcon from '~/components/main/AreaIcon';

export default {
	name: 'KnowledgeAreaBox',

	components: {
		LinkTile,
		AreaIcon,
	},

	props: {
		items: {
			type: Array,
			default: () => [],
		},
		title: {
			type: String,
			default: 'Vidensområder',
		},
	},
};
</script>

<style lang="postcss">
.c-knowledge-area-box__content {
	--icon-size: 40px;
}
@screen >=768 {
	.c-knowledge-area-box__content {
		--icon-size: 48px;
		transform: translateY(100%)
			translateY(
				calc(
					var(
							--theme-verticalSpacing-xs-v,
							var(--theme-verticalSpacing-xs-v--sm)
						) * -2 - var(--icon-size, 48px)
				)
			);
		transition: transform 0.3s ease;
	}
	.c-knowledge-area-box__hidden-content {
		opacity: 0;
		transition: opacity 0.3s ease;
	}
	.c-knowledge-area-box__heading {
		transform: translateY(-100%) translateY(var(--icon-size, 48px));
		transition: transform 0.3s ease;
	}

	.c-knowledge-area-box__item:hover,
	.c-knowledge-area-box__item:focus-within {
		& .c-knowledge-area-box__content,
		& .c-knowledge-area-box__heading {
			transform: translateY(0);
		}
		& .c-knowledge-area-box__hidden-content {
			opacity: 1;
		}
	}
}

.c-knowledge-area-box__stand-in {
	display: none;
}

@screen >=1200 {
	:not(.c-knowledge-area-box__stand-in):nth-child(4n + 1)
		+ .c-knowledge-area-box__stand-in:nth-child(4n + 2),
	:not(.c-knowledge-area-box__stand-in):nth-child(4n + 1)
		+ *
		+ .c-knowledge-area-box__stand-in:nth-child(4n + 3),
	:not(.c-knowledge-area-box__stand-in):nth-child(4n + 1)
		+ *
		+ *
		+ .c-knowledge-area-box__stand-in:nth-child(4n + 4) {
		display: block;
	}
}

@screen <1200 {
	@screen >=1024 {
		:not(.c-knowledge-area-box__stand-in):nth-child(3n + 1)
			+ .c-knowledge-area-box__stand-in:nth-child(3n + 2),
		:not(.c-knowledge-area-box__stand-in):nth-child(3n + 1)
			+ *
			+ .c-knowledge-area-box__stand-in:nth-child(3n + 3) {
			display: block;
		}
	}
}

@screen <1024 {
	:not(.c-knowledge-area-box__stand-in):nth-child(2n + 1)
		+ .c-knowledge-area-box__stand-in:nth-child(2n + 2) {
		display: block;
	}
}
</style>
